const state = {
	/**
	 * user.type Enum
	 * MEMBER(1, "会员")
	 * ADMIN(2, "管理员"),
	 * MERCHANT(3, "商家") ,
	 * CARGO_AGENT(4, "货代") ,
	 * CARGO_AGENT_STAFF(5, "货代业务员") ,
	 * PARTNER(6, "合作伙伴")
	 * 
	 {
		 userId: '',
		 accessToken: '',
		 refreshToken: '',
		 expiredsTime: 100000000000,
		 user: {
			 id: '',
			 username: '',
			 nickname: '',
			 email: '',
			 mobile: '',
			 referrerCode: null,
			 avatar: '',
			 type: 'MERCHANT'
		 }
	 }
	 * 
	 }
	 */
	user: null,
	menus: {
		MERCHANT: [{
			label: '商家页面',
			child: [{
				label: '货运保险',
				index: '/merchant/order'
			}, {
				label: '商品管理',
				index: '/merchant/product'
			}, {
				label: '申报管理',
				index: '/merchant/cargo-order'
			}, {
				label: '操作员管理',
				index: '/infos/staff'
			}]
		}],
		MERCHANT_STAFF: [{
			label: '商家页面',
			child: [{
				label: '货运保险',
				index: '/merchant/order'
			}, {
				label: '商品管理',
				index: '/merchant/product'
			}, {
				label: '申报管理',
				index: '/merchant/cargo-order'
			}]
		}],
		CARGO_AGENT: [{
			label: '合作伙伴后台',
			child: [{
				label: '操作员管理',
				index: '/infos/staff'
			},{
				label: '申报管理',
				index: '/merchant/cargo-order'
			}, {
				label: '分享&收益管理',
				index: '/stat/earnings'
			}]
		}],
		CARGO_AGENT_STAFF: [{
			label: '合作伙伴后台',
			child: [{
				label: '申报管理',
				index: '/merchant/cargo-order'
			}, {
				label: '分享&收益管理',
				index: '/stat/earnings'
			}]
		}],
		PARTNER: [{
			label: '合作伙伴后台',
			child: [{
				label: '申报管理',
				index: '/merchant/cargo-order'
			}, {
				label: '分享&收益管理',
				index: '/stat/earnings'
			}]
		}],
		ADMIN: [{
			label: '管理后台',
			child: [{
				label: '汇总看板',
				index: '/admin/data-board'
			}, {
				label: '注册信息管理',
				index: '/admin/partner'
			}, {
				label: '合作伙伴管理',
				index: '/admin/rate-level'
			}]
		}]
	},
	menuIcons: [
		'el-icon-menu', 
		'el-icon-s-order', 
		'el-icon-s-cooperation'
	],
	registerTypes: [{
		label: '公司',
		value: 0
	}, {
		label: '个人',
		value: 1
	}]
}
export default state